import { Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';

import { SkeletonLoaders } from '@hero/components';
import { formatCurrency } from '@hero/utils';

export const FormatCurrencyWithState = ({ value, isNotAvailable, isLoading, components }) => {
  if (isNotAvailable) {
    return (
      <Typography variant="subtitle3Bold" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {<components.BeforeNA />}
        N/A
      </Typography>
    );
  } else if (isLoading) {
    return <SkeletonLoaders.CostSummaryLoader />;
  }
  return <Typography variant="subtitle3Bold">{formatCurrency(value)}</Typography>;
};

FormatCurrencyWithState.propTypes = {
  value: PropTypes.number.isRequired,
  isNotAvailable: PropTypes.bool,
  isLoading: PropTypes.bool,
  components: PropTypes.shape({
    BeforeNA: PropTypes.node
  })
};
